<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" labelAlign="left"  :model="form" :rules="rules">

      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="goodsList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>选择商品<template slot="title">选择商品</template></a-tooltip> </span>
            <a-button type="dashed"  v-if="form.goodsList!=null && form.goodsList.length > 0" style="text-align: left; width: 100%" @click="openGoodsSelect" danger>
              <span style="color: dodgerblue">已选择{{form.goodsList.length}}件商品</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openGoodsSelect">选择商品</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.goodsList && form.goodsList.length> 0">
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="form.goodsList"
          :pagination="false"
          :bordered="tableBordered">
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="goodsType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType"/>
          </span>
          <span slot="isRecommend" slot-scope="text, record">
            <a-switch :disabled="!record.isSave" @change="(checked) => onRecommendChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isRecommend"/>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDeleteGoods(record.id)" >
              <a-icon type="delete" />{{$t('删除')}}
            </a>
          </span>
        </a-table>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </a-form-model>
    <goods-checkbox-select ref="goodsSelect" @goodsSelect="handleGoodsSelected"></goods-checkbox-select>
  </a-drawer>
</template>

<script>
import {
  recommendCommunityLiveGoods,
  updateCommunityLiveGoods,
  communityLiveGoodsList
} from '@/api/community/live'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import GoodsCheckboxSelect from "@/views/goods/goods/select/GoodsCheckboxSelect.vue";
import checkboxUserSelectForm from "@/views/user/user/modules/CheckboxSelectForm.vue";
import {tableMixin} from "@/store/table-mixin";
import {updateVisible} from "@/api/goods/category";


export default {
  name: 'CreateForm',
  props: {
  },
  mixins: [tableMixin],
  components: {
    checkboxUserSelectForm,
    GoodsCheckboxSelect,
    OssUploadSingle,
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      formTitle: '',
      loading: false,
      // 表单参数
      form: {
        id: null,
        goodsList: [],
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          width: 200,
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 200,
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '是否推荐',
          dataIndex: 'isRecommend',
          scopedSlots: {customRender: 'isRecommend'},
        },
        {
          title: '价格',
          dataIndex: 'price',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        liveName: [{required: true, message: '直播间名称' + this.$t('不能为空'), trigger: 'blur'}],
        theme: [{required: true, message: '直播主题' + this.$t('不能为空'), trigger: 'blur'}],
        nickName: [{required: true, message: '直播用户昵称' + this.$t('不能为空'), trigger: 'blur'}],
        avatar: [{required: true, message: '直播用户头像' + this.$t('不能为空'), trigger: 'change'}],
        thumb: [{required: true, message: '直播封面' + this.$t('不能为空'), trigger: 'change'}],
        categoryId: [{required: true, message: '直播分类' + this.$t('不能为空'), trigger: 'change'}],
        preOpenTime: [{required: true, message: '预计开播时间' + this.$t('不能为空'), trigger: 'change'}],
        screenMode: [{required: true, message: '屏幕模式' + this.$t('不能为空'), trigger: 'change'}],

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        goodsList: [],
      }

    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    // 关闭当前标签页
    openUserSelect() {
      this.$refs.checkboxUserSelectForm.openUser()
    },
    indexUserSelect(record) {
      if (!record) {
        return
      }
      record.forEach(e => {
        e.userId = e.id
      });
      const cloneData = JSON.parse(JSON.stringify(record))
      // 去重
      cloneData.forEach(e => {
        if (!this.form.actorList.find(g => g.userId === e.id)) {
          this.form.actorList.push(e)
        }
      })
    },
    onRecommendChange(checked, record) {
      let data = {liveId:record.liveId, goodsId: record.id}
      recommendCommunityLiveGoods(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.$emit('ok')
          record.isRecommend=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },

    handleDeleteGoods(id) {
      let filter = this.form.goodsList.filter(e => e.id !== id);
      this.form.goodsList =filter;
    },


    openGoodsSelect() {
      //this.form.merchantList id 数组
      let merchantIdList = []
      this.$refs.goodsSelect.openGoods(this.form.goodsList, merchantIdList,[20,21]);
    },
    handleGoodsSelected(list) {
      console.log('商品选择了:',list)
      //深拷贝
      const cloneData = JSON.parse(JSON.stringify(list))
      let goodsList = []
      //list 再 this.form.goodsList 中不存在的,添加到 this.form.goodsList 中
      list.forEach(goods => {
        if (!this.form.goodsList.find(g => g.id === goods.id)) {
          this.form.goodsList.push(goods)
        }
      });
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      communityLiveGoodsList({"id": id}).then(response => {
        this.form.goodsList = response.data
        this.form.id = id
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityLiveGoods(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.ant-card-body {
  padding: 5px;
}
</style>